export const splitNameTask = (name: string) => {
  const nameArr = name.split(' ');
  const taskName = nameArr.slice(2).join(' ');
  return taskName;
};
